import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { NoTranslate, Tooltip } from '@contently/toolkit';
import LocalizedRelativeDatetime from './relative_datetime';

// # Some locale codes are different between Localize.js and Moment.js
const localeMap = {
  'en-GB': 'en-gb',
  zh: 'zh-cn'
};

// # monthYear & monthDay will translate month names but are not fully localized formats.
const formatMap = {
  dateshorthand: 'l',
  date: 'll',
  time: 'LT',
  datetime: 'lll',
  monthYear: 'MMMM YYYY',
  monthDay: 'MMM D'
};

function LocalizedDatetime({ timestamp, locale, formatType }) {
  const momentInstance = moment(timestamp)
    .parseZone()
    .locale(localeMap[locale] || locale);
  const date = momentInstance.format(formatMap[formatType]);

  const time = momentInstance.format(formatMap.time);

  return (
    <NoTranslate>
      <Tooltip content={time}>{date}</Tooltip>
    </NoTranslate>
  );
}

LocalizedDatetime.defaultProps = {
  locale: 'en'
};

LocalizedDatetime.propTypes = {
  timestamp: PropTypes.string.isRequired,
  locale: PropTypes.string,
  formatType: PropTypes.string.isRequired
};

function Datetime({ timestamp, locale, formatType, relative }) {
  if (relative) {
    return <LocalizedRelativeDatetime timestamp={timestamp} locale={formatType} />;
  }

  return <LocalizedDatetime timestamp={timestamp} locale={locale} formatType={formatType} />;
}

Datetime.defaultProps = {
  locale: 'en',
  relative: false
};

Datetime.propTypes = {
  timestamp: PropTypes.string.isRequired,
  locale: PropTypes.string,
  formatType: PropTypes.string.isRequired,
  relative: PropTypes.bool
};

const mapStateToProps = state => ({ locale: state.localize.preferredLang });

export default connect(mapStateToProps)(Datetime);



// WEBPACK FOOTER //
// ./app/javascript/app/components/toolkit/Datetime.jsx